__turbopack_context__.v({
  "icon": "UltraBoldHeading-module-scss-module__jfjO9G__icon",
  "paragraph": "UltraBoldHeading-module-scss-module__jfjO9G__paragraph",
  "root": "UltraBoldHeading-module-scss-module__jfjO9G__root",
});
